<!--Error page starts-->
<section id="error">
  <div class="container-fluid bg-grey bg-lighten-3">
    <div class="container">
      <div class="row full-height-vh">
        <div class="col-md-12 col-lg-3 ml-auto d-flex align-items-center">
          <div class="row text-center mb-3">
            <div class="col-12">
              <img src="assets/img/logo.png" alt="User" width="300" />
            </div>
            <div class="col-12">
              <h4 class="grey darken-2 font-large-5">Opps hubo un error...</h4>
            </div>
          </div>
        </div>
        <div
          class="col-md-12 col-lg-8 d-flex align-items-center justify-content-center"
        >
          <div class="error-container">
            <div class="no-border">
              <div
                class="text-center text-bold-700 grey darken-2 mt-5"
                style="font-size: 11rem; margin-bottom: 4rem"
              >
                404
              </div>
            </div>
            <div class="error-body">
              <fieldset class="row py-2">
                <div class="input-group col-12">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Search..."
                    aria-describedby="button-addon2"
                  />
                  <span class="input-group-btn" id="button-addon2">
                    <a><i class="ft-search"></i></a>
                  </span>
                </div>
              </fieldset>
              <div class="row py-2 justify-content-center">
                <div class="col-8">
                  <a
                    [routerLink]="['/public/login/']"
                    class="btn btn-brown btn-raised btn-block font-medium-2"
                    ><i class="ft-home"></i> Ir a Login</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<app-footer class="container-fluid"></app-footer>
<!--Error page ends-->
